var $fb9d42478fabd4d2$exports = {};
$fb9d42478fabd4d2$exports = {
    "actions": `Radnje`,
    "hideButtonLabel": `Prika\u{17E}i manje`,
    "noTags": `Ne postoji`,
    "showAllButtonLabel": (args, formatter)=>`Prika\u{17E}i sve (${formatter.number(args.tagCount)})`
};


export {$fb9d42478fabd4d2$exports as default};
//# sourceMappingURL=sr-SP.mjs.map
